import { render } from "./DirectDebetPage.vue?vue&type=template&id=f8949708&scoped=true"
import script from "./DirectDebetPage.vue?vue&type=script&lang=js"
export * from "./DirectDebetPage.vue?vue&type=script&lang=js"

import "./DirectDebetPage.vue?vue&type=style&index=0&id=f8949708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8949708"]])

export default __exports__